<template>
  <div class="comment-certifier">
    <p class="description">
      <span class="span">
        Envoyer-nous la raison sociale et les contacts 
      </span>
      <span class="em">
        téléphone, adresse physique, adresse mail 
      </span>
      <span class="span">
        de votre société, avec en pièce jointe le certificat BIO ou
        l'attestation délivrée par un organisme certificateur, à
        l'adresse e-mail :
      <a href="javascript:em1();" rel="noopener noreferrer" target="_blank">
        <span class="email">se.symabio@gmail.com</span>
      </a></span>
    </p>
    <div class="button-wrapper" @click="downloadPdf">
      <div class="button-comment">Comment certifier?</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CommentCertifier",
  data() {
    return {
      pdfUrl: '/Guide_Certification.pdf' // PDF in public folder
    };
  },
  methods: {
    downloadPdf() {
      const link = document.createElement('a');
      link.href = this.pdfUrl;
      link.download = 'Guide_Certification.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};
</script>

<style>
.comment-certifier {
  margin: 0px 8vw;
  width: 48vw;
  align-items: flex-start;
  display: flex;
  gap: 12px;
  /* left: 82px; */
  padding: 0px 12px;
  /* position: absolute; */
  /* top: 230px; */
  /* width: 819px; */
}

.comment-certifier .description {
  color: transparent;
  font-family: "Mona-Sans-Light", Helvetica;
  font-size: 13px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 20px;
  margin-top: -1.00px;
  position: relative;
  /* width: 450px; */
}

.comment-certifier .span {
  color: #000000;
  font-weight: 300;
}

.comment-certifier .em {
  color: #5a5a5a;
  font-family: "Mona-Sans-MediumItalic", Helvetica;
  font-style: italic;
  font-weight: 500;
}

.comment-certifier .email {
  color: #3b723e;
  font-family: "Mona-Sans-SemiBold", Helvetica;
  font-weight: 600;
  text-decoration: underline;
}


.comment-certifier .button-wrapper {
  align-items: center;
  background-color: #3b723e;
  border-radius: 16px;
  display: flex;
  flex: 1;
  flex-grow: 1;
  gap: 4px;
  height: 61px;
  justify-content: center;
  padding: 16px;
  position: relative;
}

.comment-certifier .button-comment {
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  color: #ffffff;
  display: -webkit-box;
  font-family: "Mona-Sans-Bold", Helvetica;
  font-size: 17px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 24px;
  overflow: hidden;
  position: relative;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: fit-content;
}

.comment-certifier .button-wrapper {
  cursor: pointer;
  transition: all 0.3s ease;
}

.comment-certifier .button-wrapper:hover {
  background-color: #2d5a31;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(59, 114, 62, 0.3);
}

.comment-certifier .tdesign-component {
  height: 24px;
  position: relative;
  width: 24px;
}
@media (max-width: 1200px){
  .comment-certifier {
    width: -webkit-fill-available;
    flex-direction: column;
    margin: 0px 6vw;
  }
}

@media (max-width: 768px) {
  .comment-certifier {
    margin: 0px 6vw;
    padding: 0px 8px;
  }
  .comment-certifier .description {
    font-size: 14px;
    line-height: 22px;
  }
  .comment-certifier .button-wrapper {
    height: 56px;
    padding: 12px;
  }
  .comment-certifier .button-comment {
    font-size: 16px;
  }
}

@media (max-width: 480px) {
  .comment-certifier {
    margin: 0px 4vw;
    padding: 0px 4px;
  }
  .comment-certifier .description {
    font-size: 13px;
    line-height: 20px;
  }
  .comment-certifier .button-wrapper {
    height: 52px;
    padding: 10px;
  }
  .comment-certifier .button-comment {
    font-size: 15px;
  }
}
</style>